import { cacheTypes, getMethodByCallBack, postMethodByDispatcher } from "../../../store/api/CommonFunctions";

export const letterStatus = {
    Draft: 0,
    Refer: 1,
    Confirmed: 2,
    Registered: 3,
    RegisterConfirmed: 4,
    Closed: 5,
    Archived: 6
}
export function getNoticeList(data) {
    return dispatch => dispatch(postMethodByDispatcher("api/NoticeBoardAPI/GetNoticeList", data, "GET_NOTICE_LIST", "دریافت لیست اطلاعیه ها"));
}
export function getNoticeList_Local(data) {
    return dispatch =>
        dispatch({
            type: "GET_NOTICE_LIST",
            data: data
        });
}
export function deleteNotice(id, onDelete) {
    return () => getMethodByCallBack(`api/NoticeBoardAPI/DeleteNotice?id=${id}`, cacheTypes.NoCache, onDelete, "DELETE_NOTICE");
}
export function getNoticeRecipientsList(id, onGetData) {
    getMethodByCallBack(`api/NoticeBoardAPI/GetNoticeRecipientsList?noticeID=${id}`, cacheTypes.NoCache, onGetData, "GetNoticeRecipientsList");
}